import styled from 'styled-components';

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 24px 24px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.colors?.text || '#111827'};
  margin: 0;
`;

export const ItemCount = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const SearchContainer = styled.div`
  flex: 0 1 280px;
  min-width: 200px;
`;

export const FilterDropdownWrapper = styled.div`
  min-width: 130px;
`;

export const ViewToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding-left: 12px;
  border-left: 1px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
`;

export const ViewToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${(props) => props.$active ? props.theme.colors?.primary || '#3B82F6' : props.theme.colors?.border || '#E5E7EB'};
  background: ${(props) => props.$active ? props.theme.colors?.primaryLight || '#EFF6FF' : 'transparent'};
  border-radius: 8px;
  cursor: pointer;
  color: ${(props) => props.$active ? props.theme.colors?.primary || '#3B82F6' : props.theme.colors?.textSecondary || '#6B7280'};
  transition: all 0.15s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors?.primary || '#3B82F6'};
    color: ${(props) => props.theme.colors?.primary || '#3B82F6'};
  }
`;

export const SelectionActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #eff6ff;
  border: 1px solid #bedbff;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const SelectionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SelectedCount = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.primary || '#3B82F6'};
`;

export const SelectAllButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  background: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e9ebef;
    color: #030213;
  }
`;

export const SelectionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
  background: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #e9ebef;
    color: #030213;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CloseSelectionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  color: #0a0a0a;
  margin-left: 8px;
  transition: all 0.15s ease;

  &:hover {
    background: #e9ebef;
    color: #030213;
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  color: ${(props) => props.theme.colors?.textSecondary || '#9CA3AF'};
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text || '#111827'};
  margin: 0 0 8px 0;
`;

export const EmptyDescription = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
  margin: 0;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
`;

export const PaginationInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const PaginationText = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonCard = styled.div`
  height: 100px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 12px;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const SelectAllRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  margin-bottom: 8px;
`;

export const SelectAllLabel = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;
